import { OptionCode } from '../enums';
import * as methods from '../methods';
import { Resource } from '../Resource';
import * as transformers from '../transformers';
import { fromRaw as fromRawCycle } from './cycles';
import * as seeds from './seeds';
const rootPath = 'crops';
const toRaw = {
    create: ({ plotId, seedId }) => ({
        plot: plotId,
        seed: seedId
    }),
    update: ({ isArchived }) => ({
        archived: isArchived
    })
};
const fromRaw = {
    get: ({ id, archived, seed, plot, last_cycle, meta }) => ({
        id,
        seed: seeds.fromRaw.get(seed),
        plotId: plot,
        lastCycle: last_cycle ? fromRawCycle.get(last_cycle) : null,
        isArchived: archived,
        dryMatterTarget: meta ? meta?.[OptionCode.maizy].dry_matter_target : null
    }),
    create: ({ plot, seed }) => ({
        plotId: plot,
        seedId: seed
    })
};
const crops = Resource((requesterBuilder) => {
    const getMany = (query) => requesterBuilder({
        path: rootPath,
        requestCtx: {
            transform: transformers.paginatedResponse(fromRaw.get),
            params: {
                query: {
                    limit: query?.limit,
                    offset: query?.offset,
                    plot: query?.plotId,
                    archived: query?.isArchived
                }
            }
        }
    });
    const get = methods.get({ requesterBuilder, rootPath, fromRaw: fromRaw.get });
    const buildKeysToInvalidate = (id) => [get(id).invalidationKey, getMany().invalidationKey];
    return {
        getMany,
        get,
        getAll: methods.getAllPages({ getMany }),
        create: methods.create({
            requesterBuilder,
            rootPath,
            fromRaw: fromRaw.get,
            toRaw: toRaw.create,
            buildKeysToInvalidate: () => [getMany().invalidationKey]
        }),
        update: methods.update({
            method: 'PATCH',
            requesterBuilder,
            rootPath,
            fromRaw: fromRaw.get,
            toRaw: toRaw.update,
            buildKeysToInvalidate
        })
    };
});
export default crops;
